import React from "react";
import { PodcastUnavailableInAppTemplate } from "themes/application/common/components";

function PodcastUnavailableInApp(props) {
    return <PodcastUnavailableInAppTemplate {...props} />;
}

export default PodcastUnavailableInApp;
